import React from 'react';
import { Badge } from 'react-bootstrap';
import { hasMissingMandatoryParameters, missingMandatoryParameterBadgeLabel } from 'redux/slices/transportsImportHelpers';

type ScheduledInstanceRowStatusBadgesProps = {
  status: string;
  missingMandatoryParameters?: string[];
};

export function ScheduledInstanceRowStatusBadges({ status, missingMandatoryParameters }: ScheduledInstanceRowStatusBadgesProps) {
  return (
    <>
      <Badge bg="warning">{status}</Badge>
      {hasMissingMandatoryParameters({ missing_mandatory_parameters: missingMandatoryParameters }) && (
        <Badge bg="danger" className="ms-1" title="Set via ⋮ → Update before the run starts">
          {missingMandatoryParameterBadgeLabel(missingMandatoryParameters?.length ?? 0)}
        </Badge>
      )}
    </>
  );
}
